import React from 'react';
import styles from './history-menu/HistoryMenu.module.css';

const HistoryMenu = ({ cardConfigs, onSelectView }) => {
  return (
    <div className={styles.menuView}>
      <h1 className={styles.menuTitle}>我的收藏</h1>
      <div className={styles.cardGrid}>
        {cardConfigs.map((card) => (
          <button
            key={card.key}
            type="button"
            className={styles.menuCard}
            onClick={() => onSelectView(card)}
            aria-label={`查看${card.title}`}
          >
            <div className={styles.menuCardIcon}>{card.icon}</div>
            <div className={styles.menuCardTitle}>{card.title}</div>
            <div className={styles.menuCardCount}>{card.count}</div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default HistoryMenu;

